export const letterDistribution: { [key: string]: number } = {
  'A': 15, 'B': 2,  'C': 5,  'D': 6,  'E': 15, 'F': 1, 'G': 2, 'H': 2, 'I': 8,
  'J': 1,  'L': 5,  'M': 3,  'N': 6,  'Ñ': 1,  'O': 12,'P': 3, 'Qu': 1, 'R': 7,
  'S': 8,  'T': 5,  'U': 6,  'V': 1,  'X': 1,  'Y': 1, 'Z': 1
};

export const OldletterDistribution: { [key: string]: number } = {
  'A': 12, 'B': 2, 'C': 4, 'D': 5, 'E': 12, 'F': 1, 'G': 2, 'H': 2, 'I': 6,
  'J': 1, 'L': 4, 'M': 2, 'N': 5, 'Ñ': 1, 'O': 9, 'P': 2, 'Q': 1, 'R': 5,
  'S': 6, 'T': 4, 'U': 5, 'V': 1, 'X': 1, 'Y': 1, 'Z': 1
};
